import Miriam from "../images/Miriam_Wairimu_K.jpeg";
import Brenda from "../images/Brenda_Ngare.jpeg";
import Florence from "../images/Florence_Ballenger.jpeg";
import Sharon from "../images/Sharon_Wilhelm.jpeg";
import Susan from "../images/Susan_Chege.jpeg";
import Washington from "../images/Susan_Washington.png";
import Muthoni from "../images/Susan_Muthoni.jpeg";

import foodIcon from "../icons/food.png";
import clothingIcon from "../icons/hanger.png";
import homeIcon from "../icons/home.png";
import medicalIcon from "../icons/medical.png";

import sustainability from "../images/sustainability.jpeg";
import free_volunteering from "../images/free_volunteering.jpeg";

import carouselImage1 from "../images/gallery_images/29.jpeg";
import carouselImage2 from "../images/gallery_images/34.jpeg";
import carouselImage4 from "../images/gallery_images/3.jpeg";
import carouselImage3 from "../images/gallery_images/32.jpeg";
import carouselImage5 from "../images/gallery_images/22.jpeg";
import carouselImage6 from "../images/gallery_images/5.jpeg";
import carouselImage7 from "../images/gallery_images/36.jpeg";
import carouselImage8 from "../images/gallery_images/12.jpeg";
import carouselImage9 from "../images/gallery_images/8.jpeg";
import carouselImage10 from "../images/gallery_images/28.jpeg";
import carouselImage11 from "../images/gallery_images/30.jpeg";
import carouselImage12 from "../images/gallery_images/13.jpeg";
import carouselImage13 from "../images/gallery_images/25.jpeg";

import pic2 from "../images/gallery_images/2.jpeg";
import pic3 from "../images/gallery_images/25.jpeg";
import pic4 from "../images/gallery_images/45.jpeg";
import pic5 from "../images/gallery_images/5.jpeg";
import pic8 from "../images/gallery_images/22.jpeg";
import pic10 from "../images/gallery_images/55.jpeg";
import pic12 from "../images/gallery_images/21.jpeg";

import picture1 from "../images/gallery_images/1.jpeg";
import picture2 from "../images/gallery_images/2.jpeg";
import picture3 from "../images/gallery_images/3.jpeg";
import picture4 from "../images/gallery_images/4.jpeg";
import picture5 from "../images/gallery_images/5.jpeg";
import picture6 from "../images/gallery_images/6.jpeg";
import picture7 from "../images/gallery_images/7.jpeg";
import picture8 from "../images/gallery_images/8.jpeg";
import picture9 from "../images/gallery_images/9.jpeg";
import picture10 from "../images/gallery_images/10.jpeg";
import picture11 from "../images/gallery_images/11.jpeg";
import picture12 from "../images/gallery_images/12.jpeg";
import picture13 from "../images/gallery_images/13.jpeg";
import picture14 from "../images/gallery_images/14.jpeg";
import picture15 from "../images/gallery_images/15.jpeg";
import picture16 from "../images/gallery_images/16.jpeg";
import picture17 from "../images/gallery_images/17.jpeg";
import picture18 from "../images/gallery_images/18.jpeg";
import picture19 from "../images/gallery_images/19.jpeg";
import picture20 from "../images/gallery_images/20.jpeg";
import picture21 from "../images/gallery_images/21.jpeg";
import picture22 from "../images/gallery_images/22.jpeg";
import picture23 from "../images/gallery_images/23.jpeg";
import picture24 from "../images/gallery_images/24.jpeg";
import picture25 from "../images/gallery_images/25.jpeg";
import picture26 from "../images/gallery_images/26.jpeg";
import picture27 from "../images/gallery_images/27.jpeg";
import picture28 from "../images/gallery_images/28.jpeg";
import picture29 from "../images/gallery_images/29.jpeg";
import picture30 from "../images/gallery_images/30.jpeg";
import picture31 from "../images/gallery_images/31.jpeg";
import picture32 from "../images/gallery_images/32.jpeg";
import picture33 from "../images/gallery_images/33.jpeg";
import picture34 from "../images/gallery_images/34.jpeg";
import picture35 from "../images/gallery_images/35.jpeg";
import picture36 from "../images/gallery_images/36.jpeg";
import picture37 from "../images/gallery_images/37.jpeg";
import picture38 from "../images/gallery_images/38.jpeg";
import picture39 from "../images/gallery_images/39.jpeg";
import picture40 from "../images/gallery_images/40.jpeg";
import picture41 from "../images/gallery_images/41.jpeg";
import picture42 from "../images/gallery_images/42.jpeg";
import picture43 from "../images/gallery_images/43.jpeg";
import picture44 from "../images/gallery_images/44.jpeg";
import picture45 from "../images/gallery_images/45.jpeg";
import picture46 from "../images/gallery_images/46.jpeg";
import picture47 from "../images/gallery_images/47.jpeg";
import picture48 from "../images/gallery_images/48.jpeg";
import picture49 from "../images/gallery_images/49.jpeg";
import picture50 from "../images/gallery_images/50.jpeg";
import picture51 from "../images/gallery_images/51.jpeg";
import picture52 from "../images/gallery_images/52.jpeg";
import picture53 from "../images/gallery_images/53.jpeg";
import picture54 from "../images/gallery_images/54.jpeg";
import picture55 from "../images/gallery_images/55.jpeg";
import picture56 from "../images/gallery_images/56.jpeg";
import picture57 from "../images/gallery_images/57.jpeg";
import picture58 from "../images/gallery_images/58.jpeg";
import picture59 from "../images/gallery_images/59.jpeg";
import picture60 from "../images/gallery_images/60.jpeg";
import picture61 from "../images/gallery_images/61.jpeg";
import picture62 from "../images/gallery_images/62.jpeg";

import video1 from "../images/videos/1.mp4";
import video2 from "../images/videos/2.mp4";
import video3 from "../images/videos/3.mp4";
import video4 from "../images/videos/4.mp4";
import video5 from "../images/videos/5.mp4";
import video6 from "../images/videos/6.mp4";
import video7 from "../images/videos/7.mp4";
import video8 from "../images/videos/8.mp4";
import {
  BookOutlined,
  GiftOutlined,
  HeartOutlined,
  HomeOutlined,
  MedicineBoxOutlined,
  StarOutlined,
  TeamOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";

export const galleryVideos = [
  { id: 1, video: video1 },
  { id: 2, video: video2 },
  { id: 3, video: video3 },
  { id: 4, video: video4 },
  { id: 5, video: video5 },
  { id: 6, video: video6 },
  { id: 7, video: video7 },
  { id: 8, video: video8 },
];

export const allGalleryImages = [
  { id: 1, picture: picture1, banner: "" },
  { id: 2, picture: picture2, banner: "" },
  { id: 3, picture: picture3, banner: "" },
  { id: 4, picture: picture4, banner: "Kajiado Visit" },
  { id: 5, picture: picture5, banner: "Kajiado Visit" },
  { id: 6, picture: picture6, banner: "Kajiado Visit" },
  { id: 7, picture: picture7, banner: "Kajiado Visit" },
  { id: 8, picture: picture8, banner: "" },
  { id: 9, picture: picture9, banner: "" },
  { id: 10, picture: picture10, banner: "" },
  { id: 11, picture: picture11, banner: "" },
  { id: 12, picture: picture12, banner: "" },
  { id: 13, picture: picture13, banner: "" },
  { id: 14, picture: picture14, banner: "" },
  { id: 15, picture: picture15, banner: "" },
  { id: 16, picture: picture16, banner: "" },
  { id: 17, picture: picture17, banner: "" },
  { id: 18, picture: picture18, banner: "" },
  { id: 20, picture: picture20, banner: "" },
  { id: 21, picture: picture21, banner: "" },
  { id: 22, picture: picture22, banner: "" },
  { id: 23, picture: picture23, banner: "" },
  { id: 24, picture: picture24, banner: "" },
  { id: 25, picture: picture25, banner: "" },
  { id: 26, picture: picture26, banner: "" },
  { id: 27, picture: picture27, banner: "" },
  { id: 28, picture: picture28, banner: "" },
  { id: 29, picture: picture29, banner: "" },
  { id: 30, picture: picture30, banner: "" },
  { id: 31, picture: picture31, banner: "" },
  { id: 32, picture: picture32, banner: "" },
  { id: 19, picture: picture19, banner: "" },
  { id: 33, picture: picture33, banner: "" },
  { id: 34, picture: picture34, banner: "" },
  { id: 35, picture: picture35, banner: "" },
  { id: 36, picture: picture36, banner: "" },
  { id: 37, picture: picture37, banner: "" },
  { id: 38, picture: picture38, banner: "" },
  { id: 39, picture: picture39, banner: "" },
  { id: 40, picture: picture40, banner: "" },
  { id: 41, picture: picture41, banner: "" },
  { id: 42, picture: picture42, banner: "" },
  { id: 43, picture: picture43, banner: "" },
  { id: 44, picture: picture44, banner: "" },
  { id: 45, picture: picture45, banner: "" },
  { id: 46, picture: picture46, banner: "" },
  { id: 47, picture: picture47, banner: "" },
  { id: 48, picture: picture48, banner: "" },
  { id: 49, picture: picture49, banner: "" },
  { id: 50, picture: picture50, banner: "" },
  { id: 51, picture: picture51, banner: "" },
  { id: 52, picture: picture52, banner: "" },
  { id: 53, picture: picture53, banner: "" },
  { id: 54, picture: picture54, banner: "" },
  { id: 55, picture: picture55, banner: "" },
  { id: 56, picture: picture56, banner: "" },
  { id: 57, picture: picture57, banner: "" },
  { id: 58, picture: picture58, banner: "" },
  { id: 59, picture: picture59, banner: "" },
  { id: 60, picture: picture60, banner: "" },
  { id: 61, picture: picture61, banner: "" },
  { id: 62, picture: picture62, banner: "" },
];

export const gallery_images = [
  { id: 1, image: pic5 },
  { id: 2, image: pic2 },
  { id: 3, image: pic3 },
  { id: 4, image: pic4 },
];

export const carouselImages = [
  pic2,
  pic8,
  pic10,
  pic12,
  carouselImage1,
  carouselImage2,
  carouselImage3,
  carouselImage4,
  carouselImage5,
  carouselImage6,
  carouselImage7,
  carouselImage8,
  carouselImage9,
  carouselImage10,
  carouselImage11,
  carouselImage12,
  carouselImage13,
];

export const team = [
  {
    id: 1,
    image: Miriam,
    title: "Director",
    name: "Miriam Wairimu K",
    location: "Kenya/USA",
  },
  {
    id: 2,
    image: Brenda,
    title: "Manager",
    name: "Brenda Ngare",
    location: "USA",
  },
  {
    id: 3,
    image: Muthoni,
    title: "Manager",
    name: "Susan Muthoni",
    location: "Kenya",
  },
  {
    id: 4,
    image: Florence,
    title: "Manager",
    name: "Florence Ballenger",
    location: "USA",
  },
  {
    id: 5,
    image: Washington,
    title: "Supporting Staff",
    name: "Susan Washington",
    location: "Germany",
  },
  {
    id: 6,
    image: Susan,
    title: "Supporting Staff",
    name: "Susan Chege",
    location: "USA",
  },
  {
    id: 7,
    image: Sharon,
    title: "Supporting Staff",
    name: "Sharon Wilhelm",
    location: "USA",
  },
];

export const infoCard = [
  {
    id: 1,
    title: "Nourishing Meals",
    text: "Help provide healthy food options for those in need. Your donations can ensure that families have access to nutritious meals, promoting better health and well-being.",
    icon: foodIcon,
  },
  {
    id: 2,
    title: "Vital Medications",
    text: "Contribute to the health of individuals who cannot afford essential medications. Your support can make a difference in their lives by ensuring they receive the treatments they need.",
    icon: medicalIcon,
  },
  {
    id: 3,
    title: "Warm Clothing",
    text: "Donate to provide warm and appropriate clothing for those facing harsh conditions. Your generosity can help individuals stay safe and comfortable during difficult times.",
    icon: clothingIcon,
  },
  {
    id: 4,
    title: "Safe Housing",
    text: "Support initiatives that provide safe and stable housing for families in need. Your contributions can help create a secure environment where individuals can thrive.",
    icon: homeIcon,
  },
];

export const callToAction = [
  {
    id: 1,
    image: sustainability,
    title: "New Sustainability",
    text: "Join us in creating a greener future. Our sustainability initiatives focus on environmental conservation, promoting renewable energy, and educating communities on eco-friendly practices. Together, we can build a sustainable tomorrow.",
  },
  {
    id: 2,
    image: free_volunteering,
    title: "Free Volunteering",
    text: "Your time and skills can make a significant difference. Volunteer with us to support underprivileged communities, participate in impactful projects, and experience the joy of giving back—all at no cost to you.",
  },
];

export const focusAreas = [
  {
    icon: <GiftOutlined />,
    label: "Nourishment",
    desc: "Feeding the hungry and impoverished within the community.",
  },
  {
    icon: <BookOutlined />,
    label: "Education",
    desc: "Empowering individuals with knowledge to break the cycle of poverty.",
  },
  {
    icon: <MedicineBoxOutlined />,
    label: "Healthcare",
    desc: "Providing access to quality medical care and promoting well-being.",
  },
  {
    icon: <HomeOutlined />,
    label: "Shelter",
    desc: "Offering safe and secure living environments for those in need.",
  },
];

export const values = [
  {
    icon: <HeartOutlined />,
    label: "Compassion",
    desc: "Driven by empathy and the desire to improve lives.",
  },
  {
    icon: <StarOutlined />,
    label: "Integrity",
    desc: "Committed to honesty, transparency, and accountability.",
  },
  {
    icon: <TeamOutlined />,
    label: "Collaboration",
    desc: "Working together with organizations to maximize impact.",
  },
  {
    icon: <ThunderboltOutlined />,
    label: "Empowerment",
    desc: "Helping vulnerable individuals take control of their lives.",
  },
];

export const impactStats = [
  { value: "500+", label: "Children sheltered" },
  { value: "300+", label: "Healthcare beneficiaries" },
  { value: "1,000+", label: "Educated & trained" },
  { value: "10,000+", label: "Meals distributed" },
  { value: "200+", label: "Families supported" },
  { value: "100+", label: "Businesses supported" },
];
